import styled, { keyframes } from 'styled-components';

import { hideAnimationSpeed } from './topicTitle.sc';

export const GlobalSpinnerContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RatingRow = styled.div`
  display: flex;
  width: fit-content;
  height: 56px;
`;

export const Placeholder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: transparent;
  padding: 40px 0;
  height: 50px;
  margin-top: 5px;
`;

export const slideInHeader = keyframes`
  from {
    top: -100px;
  } to {
    top: 0;
  }
`;

export const FixedHeaderTitle = styled.div`
  width: calc(100vw - 150px);
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 15px 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 30px;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const FixedHeader = styled.div<{ $isFixed: boolean }>`
  width: 100%;
  background-color: ${({ theme }) => theme.background};
  z-index: 10;
  position: ${({ $isFixed }) => ($isFixed ? 'fixed' : 'normal')};
  animation: ${({ $isFixed }) => ($isFixed ? slideInHeader : 'none')} 350ms ease-in-out;
  top: 0;
`;

export const TableWrapper = styled.div`
  width: 100%;
  padding-left: 90px;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const InnerSpinner = styled.div`
  min-height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableBottom = styled.div`
  display: flex;
`;

export const ScrollHeader = styled.div<{ $isFixed: boolean }>`
  margin-top: ${({ $isFixed }) => ($isFixed ? '0' : '30px')};
  width: 100%;
`;

const growRow = keyframes`
  from {
    height: 0;
  } to {
    height: 70px;
  }
`;

const shrinkRow = keyframes`
  from {
    height: 70px;
  } to {
    height: 0;
  }
`;

export const GrowRow = styled.div<{ $show: boolean }>`
  width: 100%;
  display: ${({ $show }) => ($show ? 'block' : 'none')};
  height: ${({ $show }) => ($show ? '70px' : '0')};
  &:hover {
    height: auto;
  }

  transition: all 0.2s ease-in-out;
  &.exited,
  &.entering,
  &.exiting {
    overflow: hidden;
  }
  &.exited {
    display: none;
    height: 0;
  }
  &.entering {
    display: block;
    animation: ${growRow} ${hideAnimationSpeed}ms ease-in-out;
  }
  &.entered {
    height: 70px;
    display: block;
  }
  &.exiting {
    display: block;
    animation: ${shrinkRow} ${hideAnimationSpeed}ms ease-in-out;
  }
`;
